module.exports = __webpack_public_path__ + "static/media/thumbnail.0f8f2dfb.jpg";